import api from "@/services/api";

class GrantPremiumVoucher {
  execute = async (beneficiaryAssociateId: string) => {
    const response = await api().post("/associate-premium/vouchers/grant", {
      beneficiaryAssociateId,
    });
    return response.data;
  };
}

export { GrantPremiumVoucher };
